export enum LIVE_STATUSES {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  OFFLINE = 'offline',
}

export default {
  LIVE_STATUSES,
};
